import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import AsideMobileListSubcategory from "../aside-mobile-list-subcategory/aside-mobile-list-subcategory"
import logoNosotras from "../../../shared/assets/images/logo/logo-mini.svg"
import "./nav-product-subcategory.scss"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { withOutScript } from "../../../shared/utils/formatString"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"

const NavProductSubcategory = ({
  currentSubcategory,
  withFilter,
  setModalActive,
}) => {
  const resultQuery = useStaticQuery(
    graphql`
      query SUBCATEGORIES_QUERY {
        allContentfulNolSubcategoriasProductos(
          filter: { titulo: { ne: "contenido-oculto" } }
        ) {
          nodes {
            node_locale
            slug
            titulo
            categoria
          }
        }
      }
    `
  )

  const listSubCategories = resultQuery.allContentfulNolSubcategoriasProductos.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )

  const [subcategoryNavActive, setSubcategoryNavActive] = useState(false)

  const userInfoEncrypt= encryptUserInfo()
  return (
    <>
      {/* Desktop */}
      <div
        className={"f-nav-product-subcategory-desktop desktop"}
        onClick={() => setSubcategoryNavActive(prevState => !prevState)}
      >
        <img
          src={logoNosotras}
          alt="Imagen menu desplegable"
          className="f-mini-nav-subcategory"
        />
        <div className="f-title-nav-container">
          Otros productos
          <span
            className={`f-icon icon-down f-icon-drop ${
              subcategoryNavActive ? "f-icon-active" : ""
            }`}
          />
        </div>
        <div
          className={`f-list-subcategories-container
          ${subcategoryNavActive ? "f-active" : "f-inactive"}
          `}
        >
          <ul className="f-elements-container">
            {listSubCategories.map((subcategory, index) => {
              if (currentSubcategory !== subcategory.slug) {
                return (
                  <li className="f-item-subcategory" key={index}>
                    <a
                      href={removeDoubleSlash(`/productos/${subcategory.categoria}/${subcategory.slug}`)}
                      key={index}
                      className="f-item-subcategory__link"
                      onClick={() => {
                        pushDataLayerEvent({
                          event: "Interacciones - Filtro",
                          category: withOutScript(currentSubcategory),
                          sub_category: 'Otros productos',
                          action: "click",
                          label: subcategory.titulo,
                          location: window.location.href,
                          user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                          log_status: userInfoEncrypt.log_status,
                        })
                      }}
                    >
                      {subcategory.titulo}
                    </a>
                    <span className={`f-icon icon-down`} />
                  </li>
                )
              }

              return <></>
            })}
          </ul>
        </div>
      </div>
      {/* Mobile */}
      <button
        className="f-btn primary-blue-nav-products mobile"
        onClick={() =>
          setModalActive(
            <AsideMobileListSubcategory
              currentSubcategory={currentSubcategory}
              setModalActive={setModalActive}
              listSubCategories={listSubCategories}
            />
          )
        }
      >
        Otros productos
      </button>
    </>
  )
}

export default NavProductSubcategory
